module.exports = __webpack_public_path__ + "img/hub.ae1e1ea9.svg";